<template>
  <g>
    <g>
      <polygon points="75,425 145,75 425,75 425,425" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
      <g v-for="side in sides" :key="side.id">
        <g v-if="side.rand === saum">
          <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
          <g v-if="side.rand.oesenArt != inactiveOesen">
            <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
          </g>
        </g>
        <path v-if="side.rand === hohlsaum" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
        <g v-if="side.rand === keder" stroke="#b1b1b1" stroke-opacity="0">
          <polygon :points="side.keder.outside" fill="#b1b1b1"/>
          <polygon :points="side.keder.inside" fill="#8e8e8e"/>
        </g>
      </g>
    </g>
    <g v-for="(side, index) in sides" :key="index">
      <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#353535" stroke-width="1"/>
      <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#353535" stroke-width="1" fill="#353535"/>
      <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#353535" stroke-width="1" fill="#353535"/>
    </g>
    <text v-for="side in sides" :key="side.id" :x="side.labelSpace.x" :y="side.labelSpace.y" font-weight="bold" font-family="sans-serif" font-size="2.5em" fill="#232323">{{side.name}}</text>
  </g>
</template>

<script>
import DataRand from '../../../../../data/main/config/setup/rand/randArt'

export default {
  props: ['material', 'rand'],
  data () {
    return {
      saum: DataRand.randArt.saum.titleSaum.name,
      hohlsaum: DataRand.randArt.hohlsaum.title.name,
      keder: DataRand.randArt.keder.title.name,
      inactiveOesen: DataRand.randArt.saum.optionsOesenart[0].value.oesenArt
    }
  },
  methods: {
    spaceRand (x, y) {
      return (Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)))
    }
  },
  computed: {
    sides () {
      return {
        a: {
          name: 'a',
          rand: this.rand.a.type,
          oesenAnzahl: this.rand.a.type === this.saum ? this.rand.a.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: 78 + Math.sqrt(Math.pow(3, 2) + Math.pow(15, 2)),
            xEnd: 410,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return 410
            }
          },
          saum: 'M81 395 L425 395',
          hohlsaum: 'M' + (75 + 9 / 5) + ' 416 L425 416',
          keder: {
            outside: '75,425 425,425 425,416 ' + (75 + 9 / 5) + ',416',
            inside: '75,425 425,425 425,422 ' + (75 + 3 / 5) + ',422'
          },
          labelSpace: {
            x: 245,
            y: 485
          },
          border: {
            line: {
              xStart: 75,
              yStart: 445,
              xEnd: 425,
              yEnd: 445
            },
            corner: {
              start: '75,445 85,440 85,450',
              rotateStart: 'rotate(0, 75, 445)',
              end: '425,445 415,440 415,450',
              rotateEnd: 'rotate(0, 425, 445)'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          rand: this.rand.b.type,
          oesenAnzahl: this.rand.b.type === this.saum ? this.rand.b.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: 78 + Math.sqrt(Math.pow(3, 2) + Math.pow(15, 2)),
            xEnd: 142 + Math.sqrt(Math.pow(3, 2) + Math.pow(15, 2)),
            yStart: 410,
            yEnd: 90,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } else if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (75 + this.spaceRand(6, 30)) + ' 425 L' + (145 + this.spaceRand(6, 30)) + ' 75',
          hohlsaum: 'M' + (75 + this.spaceRand(9 / 5, 9)) + ' 425 L' + (145 + this.spaceRand(9 / 5, 9)) + ' 75',
          keder: {
            outside: '75,425 ' + (75 + this.spaceRand(9 / 5, 9)) + ',425 ' + (145 + this.spaceRand(9 / 5, 9)) + ',75 145,75',
            inside: '75,425 ' + (75 + this.spaceRand(3 / 5, 3)) + ',425 ' + (145 + this.spaceRand(3 / 5, 3)) + ',75 145,75'
          },
          labelSpace: {
            x: 55,
            y: 250
          },
          border: {
            line: {
              xStart: 75 - Math.sqrt(10000 / 26),
              yStart: 425 - Math.sqrt(400 / 26),
              xEnd: 145 - Math.sqrt(10000 / 26),
              yEnd: 75 - Math.sqrt(400 / 26)
            },
            corner: {
              start: (75 - Math.sqrt(10000 / 26)) + ',' + (425 - Math.sqrt(400 / 26)) + ' ' + (70 - Math.sqrt(10000 / 26)) + ',' + (415 - Math.sqrt(400 / 26)) + ' ' + (80 - Math.sqrt(10000 / 26)) + ',' + (415 - Math.sqrt(400 / 26)),
              rotateStart: 'rotate(11,' + (75 - Math.sqrt(10000 / 26)) + ',' + (425 - Math.sqrt(400 / 26)) + ')',
              end: (145 - Math.sqrt(10000 / 26)) + ',' + (75 - Math.sqrt(400 / 26)) + ' ' + (140 - Math.sqrt(10000 / 26)) + ',' + (85 - Math.sqrt(400 / 26)) + ' ' + (150 - Math.sqrt(10000 / 26)) + ',' + (85 - Math.sqrt(400 / 26)),
              rotateEnd: 'rotate(11,' + (145 - Math.sqrt(10000 / 26)) + ',' + (75 - Math.sqrt(400 / 26)) + ')'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          rand: this.rand.c.type,
          oesenAnzahl: this.rand.c.type === this.saum ? this.rand.c.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: 142 + Math.sqrt(Math.pow(3, 2) + Math.pow(15, 2)),
            xEnd: 410,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return 90
            }
          },
          saum: 'M139 105 L425 105',
          hohlsaum: 'M' + (145 - 9 / 5) + ' 84 L425 84',
          keder: {
            outside: '145,75 425,75 425,84 ' + (145 - 9 / 5) + ',84',
            inside: '145,75 425,75 425,78 ' + (145 - 3 / 5) + ',78'
          },
          labelSpace: {
            x: 275,
            y: 40
          },
          border: {
            line: {
              xStart: 145,
              yStart: 55,
              xEnd: 425,
              yEnd: 55
            },
            corner: {
              start: '145,55 155,50 155,60',
              rotateStart: 'rotate(0, 145, 55)',
              end: '425,55 415,50 415,60',
              rotateEnd: 'rotate(0, 425, 55)'
            }
          },
          id: 3
        },
        d: {
          name: 'd',
          rand: this.rand.d.type,
          oesenAnzahl: this.rand.d.type === this.saum ? this.rand.d.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: 410,
            yStart: 90,
            yEnd: 410,
            x: function (i, item) {
              return this.xStart
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } else if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M395 75 L395 425',
          hohlsaum: 'M416 75 L416 425',
          keder: {
            outside: '416,75 416,425 425,425 425,75',
            inside: '422,75 422,425 425,425 425,75'
          },
          labelSpace: {
            x: 455,
            y: 250
          },
          border: {
            line: {
              xStart: 445,
              yStart: 75,
              xEnd: 445,
              yEnd: 425
            },
            corner: {
              start: '445,75 440,85 450,85',
              rotateStart: 'rotate(0, 445, 75)',
              end: '445,425 440,415 450,415',
              rotateEnd: 'rotate(0, 445, 425)'
            }
          },
          id: 4
        }
      }
    }
  }
}
</script>

<style>
</style>
